// // src/pages/components/StatusBadge.tsx
// import React from 'react';

// interface StatusBadgeProps {
//   status: string;
// }

// function StatusBadge({ status }: StatusBadgeProps) {
//   const getStatusClass = (status: string) => {
//     switch (status) {
//       case 'TODO': return 'status-todo';
//       case 'IN_PROGRESS': return 'status-progress';
//       case 'IN_REVIEW': return 'status-review';
//       case 'BLOCKED': return 'status-blocked';
//       case 'DONE': return 'status-done';
//       case 'CANCELLED': return 'status-cancelled';
//       default: return 'status-default';
//     }
//   };

//   const getStatusLabel = (status: string) => {
//     switch (status) {
//       case 'TODO': return 'To Do';
//       case 'IN_PROGRESS': return 'In Progress';
//       case 'IN_REVIEW': return 'In Review';
//       default: return status;
//     }
//   };

//   return (
//     <span className={`status-badge ${getStatusClass(status)}`}>
//       {getStatusLabel(status)}
//     </span>
//   );
// }

// export default StatusBadge;

// src/pages/components/StatusBadge.tsx
import React from 'react';

interface StatusBadgeProps {
  status: string;
}

function StatusBadge({ status }: StatusBadgeProps) {
  const getPillClass = (s: string) => {
    switch (s) {
      case 'TODO':        return 'gt-pill is-pending';
      case 'IN_PROGRESS': return 'gt-pill is-progress';
      case 'IN_REVIEW':   return 'gt-pill is-high';
      case 'BLOCKED':     return 'gt-pill is-overdue';
      case 'DONE':        return 'gt-pill is-done';
      case 'CANCELLED':   return 'gt-pill is-ghost';
      default:            return 'gt-pill is-pending';
    }
  };

  const getStatusLabel = (s: string) => {
    switch (s) {
      case 'TODO':        return 'To Do';
      case 'IN_PROGRESS': return 'In Progress';
      case 'IN_REVIEW':   return 'In Review';
      default:            return s.charAt(0) + s.slice(1).toLowerCase();
    }
  };

  return (
    <span className={getPillClass(status)}>
      {getStatusLabel(status)}
    </span>
  );
}

export default StatusBadge;